export const RoutePath = {
  Login: "/login",
  Home: "/home",
  HomePage: "/",
  RegistrationComplete: "/registrationComplete",
  ResetPasswordComplete: "/resetPasswordComplete",
  EditUserData: "/editUserData",
  RegistrationConfirm: "/registrationConfirm/:uuid",
  SubscriptionHandle: "/subscriptionHandle",
  OrderInfo: "/orderInfo",
  ResetPassword: "/resetPassword",
  Registration: "/registration",
  Regulations: "/regulations"
};
